import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,

  TextField,
  Box,

} from "@mui/material";
import { getAllItems, deleteItem } from "../../../Services/Services";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import InfiniteScroll from "react-infinite-scroll-component";

import { useLocation } from "react-router-dom";

function MaterialReturnRegister() {

  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [filters, setFilters] = useState({
    item_code: "",
    name: "",
    category: "",
    sub_category: "",
  });


  useEffect(() => {
    const handler = setTimeout(() => {
      setPage(1); // reset page
      fetchItems(1, false); // reset data with new filters
    }, 1000);

    return () => clearTimeout(handler);
  }, [filters]);

  const fetchItems = async (page = 1, append = false) => {
    const data = await getAllItems(page, filters);

    if (append) {
      setItems((prev) => [...prev, ...data.results]);
    } else {
      setItems(data.results);
    }

    setHasMore(!!data.next); // next page hai ya nahi
  };

  const fetchMoreData = () => {
    if (hasMore) {
      fetchItems(page + 1, true); // ✅ append mode
      setPage((prev) => prev + 1);
    }
  };
  const location = useLocation();
  const editData = location.state?.data || null;

  useEffect(() => {
    if (location.state?.edited) {
      // Clear the navigation state so toast doesn't repeat on refresh
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  return (
    <InfiniteScroll
      dataLength={items.length}
      // next={fetchMoreData}
      // hasMore={hasMore}
      scrollableTarget="item-table"
    // loader={<Typography sx={{ textAlign: "center", p: 2 }}>Loading...</Typography>}
    // table scroll height
    >
      <TableContainer
        component={Paper}
        id="item-table"
        sx={{
          maxHeight: "80vh",
          overflowX: { xs: "auto", sm: "unset" }, // horizontal scroll on mobile only
          overflowY: "auto",
          width: "100%",
        }}
      >
        <Table
          stickyHeader
          size="small"
          sx={{
            minWidth: { xs: 1200, sm: 2000 }, // smaller min-width on mobile
            "& td, & th": {
              borderBottom: "1px solid #ccc",
              textAlign: "center",
              whiteSpace: "nowrap",
              backgroundColor: "#f5f5f5",
            },
          }}
        >
          <TableHead
            sx={{
              "& th": {
                fontWeight: "bold",
                color: (theme) =>
                  theme.palette.mode === "dark" ? "#2196f3" : "#333",
                backgroundColor: (theme) =>
                  theme.palette.mode === "dark" ? "black" : "#f5f5f5",
              },
            }}
          >
            <TableRow>
              {/* Sticky left: S.No */}

              <TableCell
                sx={{
                  position: "sticky",
                  left: 0,
                  backgroundColor: "#f5f5f5",
                  zIndex: 3,
                  minWidth: 40,
                  padding: "0px",
                }}
              >
                S. No.
              </TableCell>
              <TableCell

              >
                Date
              </TableCell>

              {/* Sticky second column: Code */}
              <TableCell
              >
                Return No
              </TableCell>

              <TableCell>Department</TableCell>
              <TableCell align="right">Item Name</TableCell>
              <TableCell>Qty Returned</TableCell>
              <TableCell>Unit</TableCell>
              <TableCell align="right">Reason</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {/* {items.map((item, index) => (
              <TableRow
                hover
                key={index}
                sx={{
                  backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                  "&:hover": {
                    backgroundColor: "#e3f2fd",
                    "& td": { backgroundColor: "#e3f2fd !important" },
                  },
                  "& td": {
                    paddingTop: "2px !important",
                    paddingBottom: "2px !important",
                    fontSize: { xs: "0.75rem", sm: "0.8125rem" }, // responsive font
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    color: (theme) =>
                      theme.palette.mode === "dark" ? "white" : "inherit",
                    backgroundColor: (theme) =>
                      theme.palette.mode === "dark" ? "black" : "inherit",
                  },
                }}
              >
                <TableCell
                  align="center"
                  sx={{
                    position: "sticky",
                    left: 0,
                    backgroundColor: "#fafafa",
                    zIndex: 2,
                    minWidth: 50,
                  }}
                >
                  {index + 1}
                </TableCell>

                <TableCell
                  sx={{
                    position: "sticky",
                    left: 60,
                    backgroundColor: "#fafafa",
                    zIndex: 2,
                    minWidth: 80,
                  }}
                >
                  {item.item_code}
                </TableCell>

                <TableCell>{item.name}</TableCell>
                <TableCell align="right">{item.min_quantity}</TableCell>
                <TableCell align="right">{item.current_stock}</TableCell>
                <TableCell>{item.category_name}</TableCell>
                <TableCell>{item.subcategory_name}</TableCell>
                <TableCell align="right">{item.created_by_name}</TableCell>
                <TableCell align="right">
                  {formatOnlyDate(item.created_at)}
                </TableCell>
              </TableRow>
            ))} */}
          </TableBody>
        </Table>
      </TableContainer>
    </InfiniteScroll>
  )
}

export default MaterialReturnRegister